const flexsdkScanDialogButtons = {
	addCustomer: 'Tilføj kunde til bon',
	addEntry: 'Tilføj entre til bon',
	goToCustomer: 'Gå til kundekort',
	addEntryAndGuest: 'Tilføj entre + gæst til bon',
	issueNewNumber: 'Udsted nyt kortnummer'
};

export default flexsdkScanDialogButtons;
